import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Arrow } from '../../../../icons/index';
import { sharpSansSemibold, sharpSansMedium } from '../../../../typography';
import { navy, grey, grey25 } from '@zocdoc/branding/colors';
import { MetricsClickable } from '@zocdoc/frontend-metrics';

const getSection = ({
    headerText, selectedText, dataUemId, dataTest, onClick, metricsAction, metricsElement,
}) => {
    return (
        <MetricsClickable
            action={metricsAction}
            element={metricsElement}
        >
            <ResultSection>
                <ArrowWrapper onClick={onClick}>
                    <SmallArrow
                        color={navy}
                        direction={Arrow.direction.right}
                    />
                </ArrowWrapper>
                <Header> {headerText} </Header>
                <Text
                    data-test={dataTest}
                    data-uem-id={dataUemId}
                    onClick={onClick}
                >
                    {' '}
                    {selectedText}
                </Text>
            </ResultSection>
        </MetricsClickable>
    );
};

export default class ScanCardResultsView extends Component {
    componentDidMount() {
        this.props.selectFirstCarrierAndPlan();
    }

    render() {
        const {
            carrier, plan, editCarrier, editPlan,
        } = this.props;

        if (!carrier) {
            return null;
        }

        return (
            <div>
                <ResultSectionWrapper>
                    {getSection({
                        selectedText: carrier.carrier_name,
                        onClick: editCarrier,
                        dataUemId: `carrier-${carrier.carrier_id}`,
                        dataTest: `carrier-${carrier.carrier_id}`,
                        metricsAction: 'Insurance Picker Scan - Clicked Edit Carrier',
                        metricsElement: 'VerifyCarrierCardScanned',
                        headerText: (
                            <FormattedMessage
                                defaultMessage="Verify carrier name"
                                id="InsurancePicker.ScanCard.Results.CarrierHeader"
                            />
                        ),
                    })}

                    {getSection({
                        selectedText: plan.plan_name,
                        onClick: editPlan,
                        dataUemId: `plan-${carrier.carrier_id}`,
                        dataTest: `plan-${plan.plan_id}`,
                        metricsAction: 'Insurance Picker Scan - Clicked Edit Plan',
                        metricsElement: 'VerifyPlanCardScanned',
                        headerText: (
                            <FormattedMessage
                                defaultMessage="Verify plan name"
                                id="InsurancePicker.ScanCard.Results.PlanHeader"
                            />
                        ),
                    })}
                </ResultSectionWrapper>
            </div>
        );
    }
}

const Header = styled.div`
    ${sharpSansSemibold(15, 24)}
    color: ${navy};
`;

const Text = styled.div`
    ${sharpSansMedium(15, 20)}
    color: ${grey};
`;

const ArrowWrapper = styled.div`
    float: right;
    padding: 10px 12px;
`;

const ResultSectionWrapper = styled.div`
    padding: 8px 16px;
    width: 100%;
    min-width: 320px;
`;
const ResultSection = styled.div`
    border-bottom: solid 1px ${grey25};
    padding: 10px 0px;
`;

const SmallArrow = styled(Arrow)`
    height: 12px;
`;
